import { render, staticRenderFns } from "./SendTicketDateForm.vue?vue&type=template&id=5a70b1bc&scoped=true"
import script from "./SendTicketDateForm.vue?vue&type=script&lang=ts"
export * from "./SendTicketDateForm.vue?vue&type=script&lang=ts"
import style0 from "./SendTicketDateForm.vue?vue&type=style&index=0&id=5a70b1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70b1bc",
  null
  
)

export default component.exports